// IIFE to avoid polluting the GLOBAL scope
// if you put the word GLOBAL in lowercase in the above comment
// the minifier will make a var e which we do not, no idea why that happens!
// so don't do that keep it uppercase
(() => {
	const clone = (o) => JSON.parse(JSON.stringify(o));

	window.DDC = window.DDC || {};
	window.DDC.reportToEventViewer = (data) => {
		const common = { ...data };
		if (!common.timestamp) {
			/*
				The sending of the event to the event viewer may happen later (if it is not ready now).
				We want to know when the event happened, not when it was sent, so save the timestamp now.
			*/
			common.timestamp = Date.now();
		}
		if (!common.clientEventName) {
			common.clientEventName = common.event;
		}
		/*
			Report to In-Page Event Viewer
		*/
		if (window?.DDC?.WidgetData?.['ws-event-viewer']?.ready) {
			window.dispatchEvent(
				new CustomEvent('eventViewerData', {
					detail: { common: clone(common) }
				})
			);
		} else {
			window.addEventListener(
				'wsEventViewerReady',
				() => {
					window.dispatchEvent(
						new CustomEvent('eventViewerData', {
							detail: { common: clone(common) }
						})
					);
				},
				{ once: true }
			);
		}

		/*
			Report to Event Viewer Extension
		*/
		if (window?.DDC?.WidgetData?.['event-viewer-ext']?.ready) {
			window.dispatchEvent(
				new CustomEvent('eventViewerExtEvent', {
					detail: { common: clone(common) }
				})
			);
		} else {
			window.addEventListener(
				'eventViewerExtReady',
				() => {
					window.dispatchEvent(
						new CustomEvent('eventViewerExtEvent', {
							detail: { common: clone(common) }
						})
					);
				},
				{ once: true }
			);
		}
	};
})();
